import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.SEARCH_CODE_GENERATORS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_CODE_GENERATORS_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    default:
      return state;
  }
};
